<template>
  <BaseModal
    class="modal_full"
    :has-close-button="false"
    :replic="replic"
  >
    <Hall v-bind="$attrs">
      <template #actions>
        <BaseButton
          :text="$t('actions.cancel')"
          size="s"
          @click="cancel"
        />
        <BaseButton
          :text="$t('actions.done')"
          size="s"
          @click="close"
        />
      </template>
    </Hall>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import Hall from '@/components/Hall.vue';

import CONSTANTS from '@/helpers/constants';

const {
  STEP_MODAL_CHOOSE_SEAT,
  ACTION_SUBMIT,
  ACTION_CANCEL,
} = CONSTANTS;

export default {
  name: 'ModalTickets',
  inheritAttrs: false,
  components: {
    BaseModal,
    BaseButton,
    Hall,
  },
  staticData: () => ({
    ticketsSnapshot: null,
    replic: STEP_MODAL_CHOOSE_SEAT,
  }),
  created() {
    this.initActions();
    this.createSnapshot();
  },
  methods: {
    createSnapshot() {
      this.ticketsSnapshot = [...this.$attrs.tickets];
    },
    cancel() {
      this.$emit('pick', this.ticketsSnapshot);
      this.close();
    },
    close() {
      this.$emit('close');
    },
    initActions() {
      const rootActions = [
        [ACTION_SUBMIT, this.close],
        [ACTION_CANCEL, this.cancel],
      ];

      rootActions.forEach((action) => this.$root.$on(...action));

      this.$once('hook:beforeDestroy', () => {
        rootActions.forEach((action) => this.$root.$off(...action));
      });
    },
  },
};
</script>
